import React, { useEffect, useState } from "react";
import { Card, Typography, Row, Col, Divider, Avatar, Image } from "antd";
import {
  ShopOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const OrgSettings = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const stored = sessionStorage.getItem("OrgSettings");
    if (stored) {
      setSettings(JSON.parse(stored));
    }
  }, []);

  const data = [
    {
      label: "Address",
      value: `${settings.invoice_company_address || "-"}, ${
        settings.invoice_company_city || ""
      }, ${settings.invoice_company_state || ""}${
        settings.invoice_company_state ? ", " : ""
      }${settings.invoice_company_country_code || ""} ${
        settings.invoice_company_postal_code || ""
      }`,
      icon: "fas fa-map-marker-alt",
    },
  ];

  return (
    <div className="">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6">
          <Card
            bordered={false}
            style={{
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,.08)",
            }}
          >
            <div className="text-center mb-2">
              <Image
                src="https://mycrm.ibizaccounts.com/uploads/company/6e084514d117b8e7b9aeda65e52db098.jpg"
                alt="Company Logo"
                preview={false}
                fallback="https://via.placeholder.com/120x120?text=Logo"
                style={{
                  width: 250,
                  height: 60,
                  objectFit: "contain",
                }}
              />

              <Title level={4} className="mt-3 mb-0">
                {settings.companyname || "Company"}
              </Title>
              <div className="row mt-3 text-center">
                <div className="col-6 border-end">
                  <div className="text-muted small">
                    <i className="fas fa-phone-alt text-primary me-1"></i>Phone
                  </div>
                  <div className="fw-semibold">
                    {settings.invoice_company_phonenumber || "-"}
                  </div>
                </div>

                <div className="col-6">
                  <div className="text-muted small">
                    <i className="fas fa-file-invoice text-primary me-1"></i>
                    GSTIN
                  </div>
                  <div className="fw-semibold">{settings.GSTIN || "-"}</div>
                </div>
              </div>

              <Divider />
            </div>

            {data.map((item, index) => (
              <div key={index}>
                <Row
                  justify="space-between"
                  align="middle"
                  className="py-2"
                  gutter={12}
                >
                  <Col span={10}>
                    <div className="d-flex align-items-center gap-2">
                      <i
                        className={item.icon}
                        style={{
                          color: "#1677ff",
                          width: 18,
                          textAlign: "center",
                        }}
                      />

                      <Text type="secondary" className="fw-semibold">
                        {item.label}
                      </Text>
                    </div>
                  </Col>

                  <Col span={14} className="text-end">
                    <Text strong>{item.value}</Text>
                  </Col>
                </Row>

                {index !== data.length - 1 && <Divider className="m-0" />}
              </div>
            ))}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default OrgSettings;
